import React from 'react';
import './About.css';

const About = ({ data }) => {
  return (
    <section id="about" className="about">
      <div className="container">
        <h2 className="section-title">About</h2>
        <p className="section-subtitle">
          {data.subtitle}
        </p>
        <div className="about-content">
          <div className="about-text">
            <p>
              With over {data.experience} of experience in AI integration and full-stack development, 
              I specialize in building intelligent automation systems that transform complex workflows 
              into streamlined processes.
            </p>
            <p>
              My expertise spans from cutting-edge AI technologies like Claude API and LLM integration 
              to modern web development frameworks. I've worked with enterprise clients including 
              CBC/Radio-Canada, Lufthansa, and Novaquark, delivering solutions that combine technical 
              excellence with business value.
            </p>
            <p>
              Currently based in {data.contact.location}, I'm available for AI integration projects, 
              full-stack development, and technical consulting, with flexible collaboration for US/EU timezones.
            </p>
          </div>
          <div className="about-stats">
            <div className="stat-item">
              <div className="stat-number">{data.experience}</div>
              <div className="stat-label">Years Experience</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">{data.awards.length}+</div>
              <div className="stat-label">Awards</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">50+</div>
              <div className="stat-label">Projects</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
